<div class="container">
    <div *ngIf="!game.my_team; else pendingJoin;">
        <div *ngIf="!fetchingTeams; else loadMsg">
            <app-add-team *ngIf="addingTeam" [targetGame]="game" [inGameTeams]="gameTeamCache"></app-add-team>
            <section *ngIf="!addingTeam" class="team-section md-mb">
                <button class="new-team" (click)="startAddTeam()">
                    <mat-icon aria-label="new team icon">add</mat-icon>
                    <span>Add Your Team</span>
                </button>
                <h2 *ngIf="getGameTeams().length" class="center-text">Or Join an Existing Team</h2>
                <h2 class="center-text" *ngIf="!getGameTeams().length">There are no teams registered at the moment. Be the first to join!</h2>
                <div class="team-list" *ngFor="let team of getGameTeams()">
                    <img class="rounded-avatar" [src]="team.team_image ? team.team_image: default_team_avatar" />
                    <div class="info-container">
                        <h3 class="no-m">#{{team.kt_team_id}} {{ team.team_name }}</h3>
                        <div class="info-footer">
                            <p><span *ngIf="isInvited(team.team_code) || team.in_game">{{team.in_game ? "You've played on this team before" : "You have been invited to this team"}}</span></p>
                            <button mat-flat-button [ngClass]="team.in_game || isInvited(team.team_code) ? 'own-team-btn' : 'unreg-btn'" (click)="askToJoin(team)">{{team.in_game || isInvited(team.team_code) ? 'Join!' : 'Ask to Join'}}</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>

    <p *ngIf="err" class=error-message>{{err}}</p>
    <div *ngIf="game.my_team; else leaveGameBtn" class="hrz-center lg-mb">
        <button *ngIf="!loadingRequest" class="text-button" (click)="cancelJoinRequest()">Cancel Request</button>
    </div>
</div>

<ng-template #leaveGameBtn>
    <div class="vert-center">
        <button *ngIf="!addingTeam; else goBack" class="text-button" (click)="hide()">
            <mat-icon aria-label="spectator icon">visibility</mat-icon>
            <span>Spectator Mode</span>
        </button>
        <button class="text-button" (click)="this.leaveGame()">
            <mat-icon aria-label="spectator icon">logout</mat-icon>
            <span>{{loadingRequest ? "One Moment..." : "Leave Game"}}</span>
        </button>
    </div>
</ng-template>

<ng-template #goBack>
    <button class="text-button" (click)="addingTeam = false">
        <mat-icon aria-label="spectator icon">arrow_back</mat-icon>
        <span>Go Back</span>
    </button>
</ng-template>

<ng-template #pendingJoin>
    <div class="team-joining-info">
        <h1>Request Sent!</h1>
        <img class="rounded-avatar sm-avatar" [src]="game.my_team.team_image" />
        <h2>Team #{{game.my_team.kt_team_id}} {{game.my_team.team_name}}</h2>
        <app-spinner [size]="'medium'" [message]="loadingRequest ? 'One Moment...' : 'Awaiting Reponse...'"></app-spinner>
    </div>
</ng-template>

<ng-template #loadMsg>
    <div>
        <app-spinner [size]="'medium'" [message]="'Fetching Teams...'"></app-spinner>
    </div>
</ng-template>

